import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import TagAccordion from "./TagAccordion";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import {
  makeBackendAPIRequest,
  backendBaseURL,
} from "../api_utilities/backend";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    height: "100%",
  },
  spaceBelow: {
    marginBottom: theme.spacing(2),
  },
});

class TagList extends React.Component {
  constructor(props) {
    super(props);

    this.state = { loading: true, tags: [] };
  }

  componentDidMount() {
    this.getTags();
  }

  getTags = () => {
    const url = new URL(backendBaseURL + "/song/get_tags_for_user");

    makeBackendAPIRequest({
      url: url,
      method: "GET",
      onSuccessCallback: (result) => {
        this.setState({
          loading: false,
          tags: result.tags_for_user.map((tag) => {
            return { tagName: tag.tag_name, tagCount: tag.total };
          }),
        });
      },
      onFailureCallback: () => {},
    });
  };

  render() {
    const { classes, store } = this.props;
    const { tags, loading } = this.state;

    return (
      <Card className={classes.root}>
        <Grid container spacing={3}>
          <Grid
            item
            container
            xs={12}
            justify={"flex-end"}
            className={classes.spaceBelow}
          >
            <Typography variant="overline">Tags</Typography>
          </Grid>
          {loading && tags.length === 0 ? (
            <Grid item container xs={12} justify={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <div />
          )}
          {tags.map((tag) => (
            <Grid item xs={12} key={tag.tagName}>
              <TagAccordion
                tagInfo={tag}
                onOpen={() => {}}
                onTrackRated={{
                  callback: () => {},
                  optimistic: () => {},
                }}
                onTagsUpdatedOptimistic={() => {}}
                store={store}
              />
            </Grid>
          ))}
        </Grid>
      </Card>
    );
  }
}

export default withStyles(useStyles)(TagList);
